export const ProgressIcon = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--progress-icon';
  color = color || '#0076CC';

  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M8.00014 18.7766C7.12975 18.5792 6.29382 18.2526 5.52014 17.8076"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 1.22266C13.9882 1.67673 15.7632 2.79235 17.0347 4.38686C18.3061 5.98138 18.9984 7.96031 18.9984 9.99966C18.9984 12.039 18.3061 14.0179 17.0347 15.6125C15.7632 17.207 13.9882 18.3226 12 18.7767"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.57905 15.092C2.03356 14.2995 1.61925 13.4243 1.35205 12.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.12415 8.50051C1.28415 7.55051 1.59215 6.65051 2.02415 5.82551L2.19315 5.52051"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.90698 2.57866C5.84264 1.93456 6.8923 1.47437 7.99998 1.22266"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7L8 10H12L10 13"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProgressIcon;
